<template>
	<div>
		<v-snackbar v-model="itemSavedNotif" top>
			Item Added
			<v-btn color="pink" flat @click="itemSavedNotif = false"> Close </v-btn>
		</v-snackbar>

		<v-dialog v-model="dialog" persistent :max-width="dialogWidth">
			<v-card>
				<v-form>
					<v-toolbar flat dense cad>
						<v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>

					<v-divider></v-divider>
					<v-card-text>
						<v-container grid-list-lg class="pa-0">
							<v-layout row wrap>
								<v-flex :lg7="!performanceReview" :lg12="performanceReview">
									<v-select
										v-show="type == null"
										v-model="form.type"
										:items="typesOrdered"
										:error-messages="typeErrors"
										label="Type"
										item-text="text"
										item-value="value"
										required
										@change="$v.form.type.$touch()"
										@blur="$v.form.type.$touch()"
									></v-select>

									<v-combobox
										v-show="!hideCategory"
										v-model="form.category"
										:items="categoriesOrdered"
										
										label="Select a category or create a new one"
										:error-messages="categoryErrors"
										item-text="text"
										item-value="text"
										:return-object="false"
										required
									></v-combobox>

									<v-textarea v-model="form.item" :error-messages="itemErrors" auto-grow required rows="3" box :label="this.getTypeFriendly(this.form.type)" @input="$v.form.item.$touch()" @blur="$v.form.item.$touch()"></v-textarea>
								</v-flex>
								<v-flex lg5 v-if="!performanceReview">
									<v-card flat color="grey lighten-3">
										<v-card-title class="pb-0">
											<span class="subheading grey--text">Settings</span>
										</v-card-title>

										<v-card-text>
											<v-divider />
											<v-switch v-model="form.isPerformanceReviewDiscussionPoint" append-icon="forum" :label="`Discuss this ${friendlyType} in Performance Reviews`" :hint="discussInPerformanceReviewsHint" persistent-hint></v-switch>
										</v-card-text>
									</v-card>
								</v-flex>
							</v-layout>
							<div v-show="form.type == 2">
								<v-divider class="mt-3 mb-2" />
								<v-subheader>
									Deliverables						
									<v-tooltip right max-width="350" content-class="text-xs-left">
										<v-icon class="ml-1" small color="info" slot="activator">mdi-help-circle</v-icon>
										<span>Deliverables allow you to specify specific deliverables and timeframes required of each key duty, e.g. <br><br> Key Duty: "Coordinate mail in and out of business included travelling to post office"<br><br>Deliverable: "Post office mail run completed daily by 10am"</span>
									</v-tooltip>
								</v-subheader>

								<v-data-table v-if="form.outcomes.length > 0" style="margin-bottom: 20px" hide-headers disable-initial-sort :items="form.outcomes" hide-actions class="elevation-1">
									<template slot="items" slot-scope="props">
										<tr>
											<td class="text-xs-left">{{ props.item.outcome }}</td>
											<td class="text-xs-left">
												<v-tooltip bottom>
													<v-icon v-if="!props.item.isPerformanceReviewDiscussionPoint" small slot="activator">speaker_notes_off</v-icon>
													<span>This deliverable will not be discussed in performance reviews</span>
												</v-tooltip>									
											</td>
											<td class="justify-center px-0">
												<v-icon small class="mr-2" @click="onEditOutcome(props.item)"> edit </v-icon>
												<v-icon small @click="deleteOutcome(props.item)"> delete </v-icon>
											</td>
										</tr>
									</template>
								</v-data-table>

								<div class="text-xs-left mb-3">
									<v-btn @click="onAddOutcome">Add New Deliverable</v-btn>
								</div>
							</div>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn flat @click="closeEditor">Cancel</v-btn>
						<v-btn color="primary" flat @click="submit(false)">Save</v-btn>
						<v-btn v-if="positionItem.category == null" color="primary" @click="submit(true)">Save & Close</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>

			<employee-position-item-outcome-editor v-if="editOutcomeDialog" :dialog="editOutcomeDialog" :outcome="editedOutcome" @onSubmit="submitOutcome" @onCancel="editOutcomeDialog = false" />
		</v-dialog>
	</div>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import typeFriendlyMixin from '@/mixins/typeFriendlyMixin';
	import { required } from 'vuelidate/lib/validators';
	import { mapGetters } from 'vuex';
	import EmployeePositionItemOutcomeEditor from '@/components/employee/EmployeePositionItemOutcomeEditor';

	export default {
		components: {
			EmployeePositionItemOutcomeEditor
		},
		props: {
			positionItem: {
				type: Object,
				default: () => ({
					id: null,
					category: null,
					item: null,
					outcomes: [],
					type: null,
					isPerformanceReviewDiscussionPoint: true
				})
			},
			performanceReview: {
				type: Boolean
			},
			type: {
				type: Number
			},
			allowedTypes: {
				type: Array
			},
			hideCategory: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				itemSavedNotif: false,
				dialog: true,
				types: [
					{ value: 2, text: 'Key Duty' },
					{ value: 1, text: 'KPI' },
					{ value: 0, text: 'General Discussion Point' },
					{ value: 3, text: '360 Discussion Point' }
				],
				form: null,
				editOutcomeDialog: false,
				editedOutcome: undefined
			};
		},
		watch: {
			positionItem: {
				deep: true,
				immediate: true,
				handler() {
					this.form = JSON.parse(JSON.stringify({
						id: this.positionItem.id,
						category: this.hideCategory ? 'N/A' : this.positionItem.category,
						item: this.positionItem.item,
						outcomes: this.positionItem.outcomes,
						type: this.positionItem.type != null ? this.positionItem.type : this.type,
						isPerformanceReviewDiscussionPoint: this.positionItem.isPerformanceReviewDiscussionPoint
					}));
				}
			},
			type() {
				this.form.type = this.type;
			}
		},
		computed: {
			...mapGetters({
				categories: 'categories/categories'
			}),
			allowedTypesList() {
				if (this.allowedTypes !== undefined) {
					return this.types.filter((x) => this.allowedTypes.includes(x.value));
				}
				return this.types;
			},
			categoryErrors() {
				const errors = [];
				if (!this.$v.form.category.$dirty) return errors;
				!this.$v.form.category.required && errors.push('Category is required.');
				return errors;
			},
			itemErrors() {
				const errors = [];
				if (!this.$v.form.item.$dirty) return errors;
				!this.$v.form.item.required && errors.push('Item is required.');
				return errors;
			},
			typeErrors() {
				const errors = [];
				if (!this.$v.form.type.$dirty) return errors;
				!this.$v.form.type.required && errors.push('Type is required');
				return errors;
			},
			categoriesOrdered() {
				var categories = this.categories.slice(0);
				var sorted = categories.sort((a, b) => a.text.localeCompare(b.text));
				sorted.unshift({ id: null, text: 'N/A' });
				return sorted;
			},
			typesOrdered() {
				let types = this.allowedTypesList;
				if (!this.performanceReview) {
					types = types.filter((x) => x.value !== 0);
				}
				return types;
			},
			title() {
				if (this.form.type == null) {
					return 'New Item';
				}

				return this.positionItem.category == null ? `New ${this.friendlyType}` : `Edit ${this.friendlyType}`;
			},
			friendlyType() {
				return this.getTypeFriendly(this.form.type);
			},
			friendlyTypePlural() {
				const result = this.getTypeFriendly(this.form.type, true);
				if (result == "Person Specification") {
					return "Person Specifications";
				} else {
					return result;
				}
			},
			dialogWidth() {
				return this.performanceReview ? '600px' : '800px';
			},
			discussInPerformanceReviewsHint() {
				return `${this.friendlyTypePlural} can be pulled in as discussion points in performance reviews. This setting allows you to exclude certain ${this.friendlyTypePlural} from being used in reviews.`;
			}
		},
		mixins: [validationMixin, typeFriendlyMixin],

		validations: {
			form: {
				category: { required },
				item: { required },
				type: { required }
			}
		},
		methods: {
			submit(closeOnSubmit) {
				this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					this.$store.commit("categories/ADD_MISSING_CATEGORIES", this.form.category);

					let postObj = {
						id: this.form.id != undefined ? this.form.id : this.newGuid(),
						category: this.form.category,
						item: this.form.item,
						type: this.form.type,
						outcomes: this.form.outcomes,
						isPerformanceReviewDiscussionPoint: this.form.isPerformanceReviewDiscussionPoint
					};
					this.$emit('save', postObj);

					if (!closeOnSubmit && this.positionItem.category == null) {
						this.itemSavedNotif = true;
						this.clear();
					} else {
						this.closeEditor();
					}
				}
			},
			closeEditor() {
				this.clear();
				this.$emit('closeEditor');
			},
			clear() {
				this.$v.form.$reset();
				this.form.id = null;
				this.form.item = null;
				this.form.outcomes = [];
			},
			submitOutcome(outcome) {
				if (outcome) {
					if (this.editedOutcome) {
						const foundIndex = this.form.outcomes.findIndex((x) => x.id === outcome.id);
						if (foundIndex > -1) {
							this.form.outcomes.splice(foundIndex, 1, outcome);
						}
					} else {
						this.form.outcomes.push({
							id: this.newGuid(),
							outcome: outcome.outcome,
							isPerformanceReviewDiscussionPoint: outcome.isPerformanceReviewDiscussionPoint
						});
					}
					this.editOutcomeDialog = false;
				}
			},
			deleteOutcome(outcome) {
				if (confirm('Are you sure you wish to delete?')) {
					const foundIndex = this.form.outcomes.findIndex((x) => x.id === outcome.id);
					if (foundIndex > -1) {
						this.form.outcomes.splice(foundIndex, 1);
					}
				}
			},
			onEditOutcome(outcome) {
				this.editedOutcome = Object.assign({}, outcome);
				this.editOutcomeDialog = true;
			},
			onAddOutcome() {
				this.editedOutcome = undefined;
				this.editOutcomeDialog = true;
			}
		}
	};
</script>

<style></style>
